import axios from 'axios';
import envConfig from '../config';
import { getStoredAccessToken } from '../helpers/authSession';

interface dataParams {
	url: string;
	data?: any;
	params?: any;
	headers?: any;
	appConfig?: any;
	cancel?: boolean;
	cancelToken?: any;
}

const axiosConfig = {
	baseURL: envConfig.API_ENDPOINT,
	headers: {
		'Content-Type': 'Application/json',
		'x-user-type': 'provider',
	},
};

function getApiConfig({ headers = {} }) {
	const accessToken = getStoredAccessToken();
	const mainConfig = {
		...axiosConfig,
		headers: {
			...axiosConfig.headers,
			...headers,
			...(accessToken ? { Authorization: accessToken } : {}),
		},
	};
	return mainConfig;
}

const apiCall = (ajaxParams = {}) => axios(ajaxParams);

export const GET = (data: dataParams): any => {
	const { url = '', params = {}, headers = {}, appConfig = {} } = data;
	const { cancelToken } = data;

	if (!url) {
		throw new Error('Please specify a valid API URL');
	}

	const config = getApiConfig({ headers });

	const ajaxParams = {
		...config,
		...appConfig,
		url,
		params,
		method: 'GET',
		cancelToken,
	};

	return apiCall(ajaxParams);
};

export const POST = (datas: dataParams): any => {
	const { url = '', params = {}, data = {}, headers = {}, appConfig = {} } = datas;
	if (!url) {
		throw new Error('Please specify a API URL');
	}
	const config = getApiConfig({ headers });
	if (typeof FormData !== 'undefined' && data instanceof FormData) {
		delete config.headers['Content-Type'];
	}
	const ajaxParams = {
		...config,
		...appConfig,
		url,
		data,
		params,
		method: 'POST',
	};

	return apiCall(ajaxParams);
};

export const PUT = (datas: dataParams): any => {
	const { url = '', params = {}, data = {}, headers = {} } = datas;

	if (!url) {
		throw new Error('Please specify a API URL');
	}

	const config = getApiConfig({ headers });

	const ajaxParams = {
		...config,
		url,
		data,
		params,
		method: 'PUT',
	};

	return apiCall(ajaxParams);
};

export const PATCH = (datas: dataParams): any => {
	const { url = '', params = {}, data = {}, headers = {} } = datas;

	if (!url) {
		throw new Error('Please specify a API URL');
	}

	const config = getApiConfig({ headers });

	const ajaxParams = {
		...config,
		url,
		data,
		params,
		method: 'PATCH',
	};

	return apiCall(ajaxParams);
};

export const DELETE = (datas: dataParams): any => {
	const { url = '', params = {}, data = {}, headers = {} } = datas;

	if (!url) {
		throw new Error('Please specify a API URL');
	}

	const config = getApiConfig({ headers });

	const ajaxParams = {
		...config,
		url,
		data,
		params,
		method: 'DELETE',
	};

	return apiCall(ajaxParams);
};

function responseInterceptorFunction() {
	axios.interceptors.response.use(
		function (response) {
			return response;
		},
		function (error) {
			if (error.response) {
				const {
					response: { status = 0 },
				} = error;

				if (status === 401) {
					localStorage.clear();
					setTimeout(function () {
						window.location.href = '/';
					}, 3000);
				}
				return Promise.reject(error.response);
			}
			return Promise.reject(error);
		},
	);
}

responseInterceptorFunction();
